/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUniversity} from '@fortawesome/pro-duotone-svg-icons';

const UniversityIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUniversity} {...props} />
);

export default UniversityIcon;
